import { createFeature, createReducer, on } from '@ngrx/store';
import { SharedFilterStorage } from '../../storage/storage';

import { filterConstants } from './models/filters.const';
import { FilterGroupI } from './models/filter-group.interface';
import * as actions from './shared-filters.actions';

export interface State {
  activeFilterGroups: FilterGroupI[];
  filterCount: number;
  filterGroups: FilterGroupI[];
}

export const initialState: State = {
  activeFilterGroups: filterConstants
    .map(filterGroup => filterGroup.defaultValue ? { ...filterGroup, isActive: true, value: filterGroup.defaultValue } : filterGroup)
    .filter((filterGroup) => filterGroup.isActive),
  filterCount: filterConstants
    .map(filterGroup => filterGroup.defaultValue ? { ...filterGroup, isActive: true, value: filterGroup.defaultValue } : filterGroup)
    .filter((filterGroup) => filterGroup.isActive)
    .length,
  filterGroups: filterConstants
    .map(filterGroup => filterGroup.defaultValue ? { ...filterGroup, isActive: true, value: filterGroup.defaultValue } : filterGroup),
};

const runTriggers = (filterGroups: FilterGroupI[]): FilterGroupI[] => {
  return filterGroups?.map(fg => {

    const newValue = fg?.changeValueWhen?.find(cvw => {
      const filterToCheck = filterGroups.find(fg => fg.key === cvw.filterGroup);
      if (filterToCheck?.value === cvw.hasValue) {
        return true;
      }
    });

    return {
      ...fg, value: newValue !== undefined && newValue.newValue !== undefined ? newValue.newValue : fg.value
    };

  }).map(fg => {

    const newValue = fg?.readonlyWhen?.find(rw => {
      const filterToCheck = filterGroups.find(fg => fg.key === rw.filterGroup);
      if (filterToCheck?.value === rw.hasValue) {
        return true;
      }
    });

    return {
      ...fg, readonly: newValue !== undefined ? true : fg.readonly
    };

  });
}

export default createFeature({
  name: 'sharedFilters',
  reducer: createReducer(
  initialState,
  on(
    actions.set,
    (state: State, { filterGroups }): State => {
      SharedFilterStorage.set(filterGroups);
      filterGroups = runTriggers(filterGroups);
      return ({
        ...state,
        activeFilterGroups: filterGroups.filter(
          (filterGroup) => filterGroup.isActive
        ),
        filterCount: filterGroups.filter((filterGroup) => filterGroup.isActive)
          .length,
        filterGroups,
      });
    }
  ),
  on(
    actions.update,
    (state: State): State => {
      let filterGroups = SharedFilterStorage.get().length >= 1 ? SharedFilterStorage.get() : undefined;
      filterGroups = runTriggers(filterGroups);
      return ({
        ...state,
        activeFilterGroups: filterGroups ? filterGroups.filter(
          (filterGroup) => filterGroup.isActive
        ) : state.activeFilterGroups,
        filterCount: filterGroups ? filterGroups.filter((filterGroup) => filterGroup.isActive)
          .length : state.filterCount,
        filterGroups: filterGroups ? filterGroups : state.filterGroups,
      });
    }
  ),
  on(
    actions.unset,
    (state: State, { filter }): State => {
      let filterGroups: FilterGroupI[] = state.filterGroups.map((filterGroup) => ({
        ...filterGroup,
        isActive: filterGroup.filters.find(
          (f) => f.filterKey === filter.filterKey
        )
          ? false
          : filterGroup.isActive,
        value: filterGroup.filters.find(
          (f) => f.filterKey === filter.filterKey
        )
          ? null
          : filterGroup.value,
      }));
      filterGroups = runTriggers(filterGroups);
      SharedFilterStorage.set(filterGroups);
      return ({
        ...state,
        activeFilterGroups: filterGroups.filter((filterGroup) => filterGroup.isActive),
        filterCount: filterGroups.filter((filterGroup) => filterGroup.isActive).length,
        filterGroups,
      });
    }
  ),
  on(
    actions.reset,
    (_state: State, { }): State => ({
      ...initialState,
    })
  )
  )}
);